var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransferOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1746429874587,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 15484,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.088 959.104a32 32 0 0 1-32-32A445.76 445.76 0 0 1 337.92 515.52a443.008 443.008 0 0 1 173.888-35.136 447.36 447.36 0 0 1 136.512 21.184 32 32 0 0 1-19.52 60.864 383.168 383.168 0 0 0-499.584 364.544 32.256 32.256 0 0 1-32.128 32.128zM511.68 473.6a204.8 204.8 0 0 1-204.032-192.576 203.2 203.2 0 0 1 51.392-147.84 204.608 204.608 0 0 1 356.928 124.16 204.608 204.608 0 0 1-192.32 216c-3.968 0.128-7.936 0.256-11.968 0.256zM503.68 128.832a139.328 139.328 0 0 0-96.768 46.848 139.52 139.52 0 0 0-35.328 101.632c4.48 77.312 71.104 136.576 148.416 132.096s136.64-71.104 132.096-148.416A140.672 140.672 0 0 0 503.68 128.832z",
    "p-id": 15485
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M670.464 673.344l283.84 14.784-101.696 270.592-182.144-285.376zM341.888 833.856c174.272 104.256 386.24-70.08 386.24-70.144l66.688 104.512s-265.216 198.528-452.928-34.368z",
    fill: "#89CDF7",
    "p-id": 15486
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferOut);
export default __webpack_public_path__ + "static/media/transferOut.a09455d966d296456038c8e0d110029e.svg";
export { ForwardRef as ReactComponent };